import { FooterProps as RDPFooterProps } from 'react-day-picker'

interface FooterProps extends RDPFooterProps {
  onClearDatesClick?: () => void
}

export function Footer({ onClearDatesClick }: FooterProps) {
  return (
    <tfoot>
      <tr>
        <td className="py-4 px-2 text-left" colSpan={7}>
          <button
            className="type-body-9 underline underline-offset-2 text-neutral-700"
            type="button"
            onClick={onClearDatesClick}
          >
            Clear dates
          </button>
        </td>
      </tr>
    </tfoot>
  )
}

export default function footerWithProps(props: FooterProps) {
  return function FooterWithProps() {
    return <Footer {...props} />
  }
}
